<script lang="ts">
	interface Props {
		row: Record<string, string>
		key: string
	}

	let { row, key }: Props = $props()

	const label = $derived(row[key])
</script>

<div class="label-container">
	<div class="label">
		{label}
	</div>
	<div class="secondary-text">
		{label}
	</div>
</div>

<style>
	.label-container {
		display: flex;
		flex-direction: column;
	}
	.label {
		font-family: 'inter', sans-serif;
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
		color: rgba(0, 22, 38, 0.9);
	}
	.secondary-text {
		font-family: 'inter', sans-serif;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		color: rgba(0, 29, 51, 0.7);
	}
</style>
